// Module
var code = "<sw-page> <sw-card> <sw-card-main ng-switch=\"$ctrl.currentLanguage$ | async\"> <div ng-switch-when=\"nl-nl\" ng-bind-html=\"$ctrl.content['nl-nl']\"></div> <div ng-switch-when=\"en-gb\" ng-bind-html=\"$ctrl.content['en-gb']\"></div> <div ng-switch-default ng-bind-html=\"$ctrl.content['en-gb']\"></div> </sw-card-main> </sw-card> </sw-page> ";
// Exports
export default code;